import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SecurityService } from 'src/app/services/security.service';
import { Router, RouterModule } from '@angular/router';
import { LoggerService } from 'src/app/services/logger.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { UserPermissionsService } from 'src/app/services/user-permissions.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule, TranslateModule]
})
export class MenuComponent implements OnInit, OnDestroy {
  isDrawerOpen = false;
  isReportsOpen = false;
  hasPartner: boolean = false;
  private refundPermissionsLoadedSuccessfully = false;
  private logger: LoggerService;
  private readonly menuPermissionRequirements: Record<string, string[]> = {
    'Historial de Transacciones': ['onboarding.history.getTransactions'],
  };

  constructor(
    private auth: AuthService, 
    private securityService: SecurityService,
    private router: Router,
    private userPermissionsService: UserPermissionsService
  ) {
    this.logger = new LoggerService();
  }

  ngOnInit(): void {
    const partnerId = this.securityService.getTokenPartner();
    this.hasPartner = partnerId !== null && partnerId !== undefined;

    this.refundPermissionsLoadedSuccessfully = false;
    this.userPermissionsService.loadCurrentUserPermissions().subscribe({
      next: (response) => this.refundPermissionsLoadedSuccessfully = response !== null && response !== undefined,
      error: (error) => {
        this.refundPermissionsLoadedSuccessfully = false;
        console.error('[PERMISSIONS] Error cargando permisos del usuario:', error);
      },
    });
  }

  canSeeMenu(menuName: string): boolean {
    if (!this.hasPartner && menuName !== 'Preferencias') {
      return false;
    }

    if (!this.userPermissionsService.hasMenu(menuName)) {
      return false;
    }

    const requiredPermissions = this.menuPermissionRequirements[menuName];
    return !requiredPermissions?.length || this.userPermissionsService.hasAnyPermission(requiredPermissions);
  }

  canSeeReports(): boolean {
    return this.securityService.isSuperAdmin() ||
      this.canSeeMenu('Historial de Transacciones') ||
      this.canSeeMenu('Cargos Aplicados') ||
      this.canSeeRefundReport();
  }

  canSeeServiceLaunchReport(): boolean {
    return this.securityService.isSuperAdmin();
  }

  canSeeRefundReport(): boolean {
    return this.refundPermissionsLoadedSuccessfully &&
      this.userPermissionsService.hasPermission('onboarding.reports.refunds');
  }

  toggleDrawer(): void {
    this.isDrawerOpen = !this.isDrawerOpen;
    this.setDrawerScrollLock(this.isDrawerOpen);
  }

  closeDrawer(): void {
    this.isDrawerOpen = false;
    this.setDrawerScrollLock(false);
  }

  toggleReports(): void {
    this.isReportsOpen = !this.isReportsOpen;
  }

  ngOnDestroy(): void {
    this.setDrawerScrollLock(false);
  }

  private setDrawerScrollLock(isLocked: boolean): void {
    globalThis.document?.body?.classList.toggle('menu-drawer-open', isLocked);
  }


  logout() {
    this.logger.log('🚪 [MENU] Iniciando logout');
    
    // Limpiar sesión usando AuthService (limpia localStorage completo)
    this.auth.closeSesion();
    this.logger.log('🧹 [MENU] localStorage limpiado');
    
    // Usar SecurityService.logout() para limpiar tokens y resetear estado de PIN
    // NOTA: SecurityService.logout() ya navega a /login, así que no necesitamos hacerlo aquí
    this.securityService.logout();
    this.logger.log('✅ [MENU] Logout completado - Redirigiendo a login');
  }
}
